function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M215 0v5H33l.036-5H215z",
  fill: "#8585FF"
});

function SvgMiddle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 274 5",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjc0IDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTIxNSAwdjVIMzNsLjAzNi01SDIxNXoiIGZpbGw9IiM4NTg1RkYiLz4KPC9zdmc+";
export { SvgMiddle as ReactComponent };